
<template lang="pug">
.building
  .flex.justify-between
    .text-base.font-bold {{ building.config.fullname }}
    .text-base.font-bold Level {{ building.config.level }}

  hr.mb-2

  p.text-sm {{ building.config.description }}

  .status.mt-4(v-if="Object.values(building.config.stores).length > 0")
    .mb-2.label.font-black.text-xs.uppercase.text-left STORAGE
    .storage.flex.justify-start
      .cost.whitespace-no-wrap.mr-4.flex(v-for="(amount, id) in building.contains")
        Icon(:item="id" size="sm")
        span.value {{ Math.floor(amount) }}/{{ building.config.stores[id] }}

    .mb-8

  .status.mt-4(v-if="Object.values(building.config.provides).length > 0")
    .mb-2.label.font-black.text-xs.uppercase.text-left Production

    h2.text-base.font-semibold.mb-2.text-left
      | Every {{ building.config.time / 10 }} secs
      span(v-if="! building.isEnabled")  (paused)
    .production.flex.justify-start
      .cost.whitespace-no-wrap.mr-4.flex(v-for="(amount, id) in building.config.costs")
        Icon(:item="id" size="sm")
        span.value -{{ Math.floor(amount) }}
      .cost.whitespace-no-wrap.mr-4.flex(v-for="(amount, id) in building.config.provides")
        Icon(:item="id" size="sm")
        span.value +{{ Math.floor(amount) }}

    .mb-12

    .enabler(v-if="building.config.canBeDisabled")
      a.btn-block(v-if="! building.isEnabled" @click="performEnable") Resume building
      a.btn-block(v-if="building.isEnabled" @click="performDisable") Pause building

      hr

      a.btn-block(v-if="! building.isEnabled" @click="performEnableAll") Resume all
      a.btn-block(v-if="building.isEnabled" @click="performDisableAll") Pause all

  br

  a.btn-block(@click="performMove") Move building

  hr.m-4

  .m-6

  a.btn-block.btn-delete(@click="performDestroy") Destroy building

  .m-6

  .upgrade-content.mt-8(v-if="upgradable(building)")
    .upgrade.shadow-md.p-4.mb-4.rounded-md.border
      h2.text-base.font-semibold.whitespace-no-wrap Upgrade to level {{ upgrade.config.level }}

      hr.mb-6.mt-2

      .status(v-if="Object.values(upgrade.config.stores).length > 0")
        .mb-2.label.font-black.text-xs.uppercase.text-left Storage
        .storage.flex.justify-start
          .cost.whitespace-no-wrap.mr-4.flex(v-for="(amount, id) in upgrade.config.stores")
            Icon(:item="id" size="sm")
            span.value {{ Math.floor(amount) }}

      .status(v-if="Object.values(upgrade.config.provides).length > 0")
        .mb-2.label.font-black.text-xs.uppercase.text-left Production

        h2.text-base.font-semibold.mb-2.text-left Every {{ upgrade.config.time / 10 }} secs
        .production.flex.justify-start
          .cost.whitespace-no-wrap.mr-4.flex(v-for="(amount, id) in upgrade.config.costs")
            Icon(:item="id" size="sm")
            span.value -{{ Math.floor(amount) }}
          .cost.whitespace-no-wrap.mr-4.flex(v-for="(amount, id) in upgrade.config.provides")
            Icon(:item="id" size="sm")
            span.value +{{ Math.floor(amount) }}

      hr.mb-2.mt-6

      a.btn-block.mt-2(@click="performUpgrade" :class="canAffordUpgrade ? 'available' : 'unavailable'") Upgrade building

      .costs.flex.flex-wrap.justify-end
        p.text-sm.pr-2 Costs:
        .cost.whitespace-no-wrap.mr-4.flex(v-for="(amount, id) in upgrade.config.constructionCosts")
          Resource(:item="id" :amount="amount" :canAfford="canRetrieve({ [id]: amount })")

  a.btn-block.disabled.mt-20(disabled="disabled" v-if="! upgradable(building)") Max Level

</template>

<script>

import Resource from '@/components/Resource'

export default {
  name: 'BuildingInfo',
  props: [ 'inventory', 'building', 'upgrade', 'canAffordUpgrade' ],
  components: { Resource },
  methods: {
    upgradable (building) {
      return building.config.level < building.config.levelMax
    },

    performEnable () {
      this.$emit('enable')
    },
    performDisable () {
      this.$emit('disable')
    },
    performEnableAll () {
      this.$emit('enable-all')
    },
    performDisableAll () {
      this.$emit('disable-all')
    },
    performUpgrade () {
      this.$emit('upgrade')
    },
    performMove () {
      this.$emit('move')
    },
    performDestroy () {
      if (confirm('Are you sure?')) {
        this.$emit('destroy')
      }
    },

    canRetrieve (wants) {
      let contents = this.inventory
      for (let i in wants) {
        if (!contents[i]) {
          return false
        }
        if (contents[i] < wants[i]) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.building {
  .name {
    font-size: 8px;
    line-height: 8px;
    font-weight: 700;
    padding-top: 4px;
    padding-bottom: 4px;

  .provides,.stores {
    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      .amount {
        font-size: 12px;
        line-height: 20px;
        font-weight: 700;

        &.negative {
          color: #d80c0c;

        }
      }
    }
  }
  }
}</style>



// WEBPACK FOOTER //
// src/components/BuildingInfo.vue